"use client";
import { useEffect, useState } from "react";
import AnimatedText from "./AnimatedText";
import AnimatedBlock from "./AnimatedBlock";
import AnimatedLink from "./AnimatedLink";
import Button from "./Button";
import { sanity } from "@/lib/sanity";
import translations from "@/lib/translations";
import { usePathname } from "next/navigation";
import GiftWheelTrigger from "@/components/GiftWheel";
import Squircle from "@/components/Squircle";

const socials = await sanity.fetch(`*[_type == "social"]{
  _id,
  title,
  url,
  icon
}`);

function SafeSvg({ svg, ...props }) {
	const [ready, setReady] = useState(false);
	useEffect(() => setReady(true), []);
	if (!ready) return null;
	return <span {...props} dangerouslySetInnerHTML={{ __html: svg }} />;
}

export default function Footer({ lang }) {
	if (!lang) return null;

	const pathname = usePathname();
	const isContactPage = pathname.includes("/contact");

	return (
		<footer>
			{!isContactPage && (
				<section>
					<div className="inner-section">
						<AnimatedBlock className="cta">
							<div className="box">
								<Squircle size="box" />
								<div className="row">
									<div className="col-12">
										<AnimatedText variant="bounce">
											<h2>
												<span className="sub-text">{translations.footerText1[lang]}</span>
												{translations.footerText2[lang]}
											</h2>
										</AnimatedText>
										<div className="separator-s"></div>
										<AnimatedText variant="fade h5">{translations.footerText3[lang]}</AnimatedText>
										<div className="separator-s"></div>
										<AnimatedBlock className="button">
											<AnimatedLink href={`/${lang}/contact`}>
												<Button>{translations.contactLabel[lang]}</Button>
											</AnimatedLink>
										</AnimatedBlock>
									</div>
								</div>
							</div>
						</AnimatedBlock>
					</div>
				</section>
			)}
			<section>
				<div className="inner-section bottom-footer padding">
					<div className="row">
						<div className="col-12">
							<AnimatedBlock className="socials">
								{socials.map((s) => (
									<div key={s._id} className="icon-wrapper">
										<a href={s.url} target="_blank" rel="noopener noreferrer" className="icon">
											<SafeSvg svg={s.icon} />
										</a>
									</div>
								))}
							</AnimatedBlock>
							<div className="text-block">
								<AnimatedText variant="fade">
									<p>
										{translations.footerLegals[lang]}
										<br className="mobile-only" /> {translations.footerLegals2[lang]}
									</p>
								</AnimatedText>
								<div className="links-footer">
									<AnimatedText variant="fade">
										<AnimatedLink href={`/${lang}/legal`}>{translations.footerLegalLabel[lang]}</AnimatedLink>
									</AnimatedText>
									<GiftWheelTrigger lang={lang} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</footer>
	);
}
